import { Injectable } from '@angular/core';
import { TreeSelectModel } from '@hrra/common-models';
import { ApiResponse } from '@hrra/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class SpecializationService {
  public abstract getTreeSelectSpecializations() : Observable<ApiResponse<TreeSelectModel<string>[], {}>>; 
}